import React, { useState, useCallback } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Container,
  Typography,
  styled,
  TablePagination,
  IconButton,
  Box,
  Chip,
} from "@mui/material";
import { Edit } from "@mui/icons-material";

// Estilos
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&.MuiTableCell-head": {
    backgroundColor: "#19438C",
    color: "white",
    fontSize: 16,
  },
  "&.MuiTableCell-body": {
    fontSize: 14,
    borderRight: "none",
    borderLeft: "none",
  },
}));

const ListaVehiculos = ({ vehiculos, onEdit }) => {
  // Estados para la paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  // Función para obtener el color del chip según el estado
  const getEstadoColor = (estado) => {
    switch (estado) {
      case "Activo":
        return "success";
      case "Inactivo":
        return "error";
      case "Mantenimiento":
        return "warning";
      case "en_ruta":
        return "primary";
      default:
        return "default";
    }
  };

  // Calcular los vehículos a mostrar en la página actual
  const vehiculosPaginados = vehiculos.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Container style={{ marginTop: 0, padding: 0 }}>
      <Typography variant="h6" component="h2" gutterBottom>
        Listado de Vehículos
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>Marca</StyledTableCell>
              <StyledTableCell>Modelo</StyledTableCell>
              <StyledTableCell>Placa</StyledTableCell>
              <StyledTableCell>Color</StyledTableCell>
              <StyledTableCell>VIN</StyledTableCell>
              <StyledTableCell>Año</StyledTableCell>
              <StyledTableCell>Fecha de adquisición</StyledTableCell>
              <StyledTableCell>Kilometraje</StyledTableCell>
              {/* <StyledTableCell>Tipo combustible</StyledTableCell> */}
              <StyledTableCell>Estado</StyledTableCell>
              <StyledTableCell>Acciones</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {vehiculosPaginados.map((vehiculo, index) => (
              <StyledTableRow key={vehiculo.id || index}>
                <StyledTableCell>{vehiculo.marca}</StyledTableCell>
                <StyledTableCell>{vehiculo.modelo}</StyledTableCell>
                <StyledTableCell>{vehiculo.placa}</StyledTableCell>
                <StyledTableCell>{vehiculo.color}</StyledTableCell>
                <StyledTableCell>{vehiculo.vin}</StyledTableCell>
                <StyledTableCell>{vehiculo.año}</StyledTableCell>
                <StyledTableCell>{vehiculo.fecha_adquisicion}</StyledTableCell>
                <StyledTableCell>
                  {parseInt(vehiculo.kilometraje).toLocaleString("es-HN")} km
                </StyledTableCell>
                {/* <StyledTableCell>{vehiculo.tipo_combustible}</StyledTableCell> */}
                <StyledTableCell>
                  <Chip
                    label={vehiculo.estado}
                    color={getEstadoColor(vehiculo.estado)}
                    size="small"
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <IconButton
                    color="primary"
                    onClick={() => onEdit(vehiculo)}
                    title="Editar vehículo"
                  >
                    <Edit />
                  </IconButton>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {vehiculos.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 20]}
          component="div"
          count={vehiculos.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Filas por página"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count}`
          }
        />
      )}
      {vehiculos.length === 0 && (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <Typography variant="body1" color="textSecondary">
            No hay vehículos registrados
          </Typography>
        </Box>
      )}
    </Container>
  );
};

export default ListaVehiculos;
